import request from '@/utils/request'

// 查询师傅端提现列表
export function listHomeWorkerWithdraw(query) {
  return request({
    url: '/homeworker/withdraw/list',
    method: 'get',
    params: query
  })
}

// 查询师傅端提现分页
export function pageHomeWorkerWithdraw(query) {
  return request({
    url: '/homeworker/withdraw/page',
    method: 'get',
    params: query
  })
}

// 查询师傅端提现详细
export function getHomeWorkerWithdraw(data) {
  return request({
    url: '/homeworker/withdraw/detail',
    method: 'get',
    params: data
  })
}

// 编辑师傅端提现
export function updateHomeWorkerWithdraw(data) {
  return request({
    url: '/homeworker/withdraw/edit',
    method: 'post',
    data: data
  })
}
